export default "__VITE_ASSET__bc7bc9d0__"